import { classNames } from "@/utils/classNames";
import { useTranslation } from "@/stores/RootStoreContext";
import { Icon, IconProps } from "./Icon";
import { TMessage } from "@/i18n/tt";
import { observer } from "mobx-react";

export const Spinner = ({ size, className }: { className?: string; size?: IconProps["size"] }) => {
  return (
    <Icon name={"circle-notch"} className={classNames("animate-spin", className)} size={size} />
  );
};

export type LoadingIndicatorProps = {
  size?: "sm" | "md" | "lg";
  label?: string | TMessage | false;
  fullscreen?: boolean;
  shimmer?: boolean;
  inline?: boolean;
};

export const LoadingIndicator = observer((props: LoadingIndicatorProps) => {
  const { tf } = useTranslation();
  const label = tf(props.label ?? { key: "loading" });
  const containerClassNames = classNames(
    props.inline ? "inline-flex" : "flex",
    props.inline && "align-middle",
    "gap-2",
    "items-center",
    props.fullscreen && ["absolute", "inset-0", "justify-center"],
  );
  const labelClassNames = classNames(props.shimmer && "shimmer");
  switch (props.size) {
    case "sm":
      return (
        <div className={containerClassNames}>
          <Spinner size={"sm"} className={"color-primary"} />
          {label && <div className={classNames("text-sm", labelClassNames)}>{label}</div>}
        </div>
      );
    case "md":
      return (
        <div className={containerClassNames}>
          <Spinner size={"md"} className={"color-primary"} />
          {label && <div className={labelClassNames}>{label}</div>}
        </div>
      );
    default:
      return (
        <div className={`${containerClassNames} flex-col`}>
          {label && <div className={classNames("text-h3", labelClassNames)}>{label}</div>}
          <Spinner size={"xxl"} className={"color-primary"} />
        </div>
      );
  }
});
